import jquery from 'jquery';


let loadPromise: Promise<void> | null = null;

export function loadWistiaAPI(): Promise<any> {
    if (loadPromise == null) {
        window['_wq'] = window['_wq'] || [];

        loadPromise = new Promise((resolve, reject) => {
            jquery.getScript('//fast.wistia.com/assets/external/E-v1.js')
                .done(() => resolve(window['_wq']))
                .fail(reject)
        })
    }

    return loadPromise;
}

export function ensureWistiaVideoDivExists(
    videoId: string,
    additionalClasses: string,
    create: (videoElement: JQuery) => void) {
    const existingDiv = jquery(`.wistia_embed.wistia_async_${videoId}`);

    if (existingDiv.length === 0) {
        const videoElement = jquery('<div />')
            .addClass(`${additionalClasses} wistia_embed wistia_async_${videoId}`);

        create(videoElement);
    }
}
